export default {
  userInfo: {}
};



// WEBPACK FOOTER //
// ./src/store/state.js